import React, { useEffect, useState, Fragment } from "react";
import Select from "react-select";
import Firebase from "../../firebasehelper";
import NoteItem from "../../components/NoteItem";
import { getStringfromSeconds } from "../../functions";
import { noteOptions } from "../../Utils/Constants";
import { skills } from "../../Constants/taskers";
import "./index.css";
import HexHover from "../HexHover";

const TicketDetailModal = ({
  brandData,
  ticketId,
  roomId,
  userIcon,
  uid,
  membername,
  username,
  ticketIssues,
  onClickAttachment,
}) => {
  const [ticketContent, setTicketContent] = useState(null);
  const [response_sla, setResponseSLA] = useState("None");
  const [repair_sla, setRepairSLA] = useState("None");
  const [selectedTicketType, setSelectedTicketType] = useState(null);
  const [selectedTicketIssue, setSelectedTicketIssue] = useState(null);
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [selectedTasker, setSelectedTasker] = useState(null);
  const [isNoteVisible, setIsNoteVisible] = useState(false);
  const [ticketTypes, setTicketTypes] = useState([]);
  const [taskers, setTaskers] = useState([]);

  const HexButton = HexHover("button", brandData.hex);

  const getSelectedTicketType = async (content) => {
    const sectors = await Firebase.getAllSectors();
    const { sector } = brandData;
    const ticket_types = sectors[sector].ticket_types;
    setTicketTypes(ticket_types);

    const ticketType = ticket_types.find((i) => i.code === content.id);

    if (ticketType)
      setSelectedTicketType({
        label: ticketType.name,
        value: ticketType,
      });
  };

  const getTaskers = (brandData) => {
    Firebase.getTaskersByBrandID(brandData, (res) => {
      setTaskers(res);
    });
  };

  useEffect(() => {
    if (ticketId) {
      // if (ticket.ticket_id <= 14) {
      //   Firebase.getAnswerfromTicket(ticket.ticket_id, (res) => {
      //     setResponseSLA(res.response_sla);
      //     setRepairSLA(res.repair_sla);
      //   });
      // }
      Firebase.getTicketData(roomId, ticketId, (content) => {
        setTicketContent(content);
        getSelectedTicketType(content);
      });
      getTaskers(brandData);
    }
  }, [ticketId, roomId]);

  const getCategoryNumber = (ticket) => {
    return ticket.toString().split(".")[0];
  };

  // -- handler

  const handleSelectTicketType = (ticketType) => {
    setSelectedTicketType(ticketType);
  };
  const handleSelectTicketIssue = (ticketIssue) => {
    setSelectedTicketIssue(ticketIssue);
  };
  const handleSelectSkill = (skill) => {
    setSelectedSkill(skill);
  };
  const handleSelectTasker = (tasker) => {
    setSelectedTasker(tasker);
  };
  return (
    <div
      className="modal fade modal-container"
      id="ticket_detail"
      tabIndex="1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Ticket Detail</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            className="modal-body pb-1"
            style={{ height: 570, fontSize: 12, overflowY: "auto" }}
          >
            {ticketContent && (
              <div className="ticket-container" id="containerElement">
                <div className="ticket-detail-brand">
                  <div className="ticket-detail-profile">
                    {userIcon && (
                      <img
                        className="avatar"
                        src={userIcon}
                        alt="ticket brand"
                      />
                    )}
                    <h3 className="ticket-detail-membername">{membername}</h3>
                  </div>
                  <HexButton
                    className="btn btn-white"
                    data-toggle="modal"
                    data-target="#manifest_modal"
                  >
                    View user manifest
                  </HexButton>
                  {/* {brandData && (
                    <img
                      className="ticket-detail-brand-logo"
                      src={brandData.logo}
                      alt="ticket brand"
                    />
                  )} */}
                </div>
                <p>Date Created: {getStringfromSeconds(ticketContent.time)}</p>
                <div className="note-select-container">
                  <p>Ticket Type:</p>
                  <Select
                    placeholder="Select Ticket Type"
                    className="select"
                    classNamePrefix="note-select"
                    value={selectedTicketType}
                    onChange={handleSelectTicketType}
                    options={[
                      { value: "Support", label: "Support" },
                      ...ticketTypes.map((type) => ({
                        value: type,
                        label: type.name,
                      })),
                    ]}
                  />
                </div>
                {/* <div className="note-select-container">
                  <p>Ticket issue:</p>
                  <Select
                    placeholder="Select Ticket Issue"
                    className="select"
                    classNamePrefix="note-select"
                    value={selectedTicketIssue}
                    onChange={handleSelectTicketIssue}
                    options={ticketIssues.map((ticketIssue) => ({
                      value: ticketIssue,
                      label: ticketIssue.issue,
                    }))}
                  />
                </div> */}
                <div className="note-select-container">
                  <p>Tasker</p>
                  <Select
                    placeholder="Allocate a tasker"
                    className="select"
                    classNamePrefix="note-select"
                    value={selectedTasker}
                    onChange={handleSelectTasker}
                    options={taskers.map((tasker) => ({
                      value: tasker,
                      label: tasker.firstName,
                    }))}
                  />
                </div>
                {/* <div className="note-select-container policy-select">
                  <p>Tasker Skill</p>
                  <Select
                    placeholder="Select a skill"
                    className="select"
                    classNamePrefix="note-select"
                    value={selectedSkill}
                    onChange={handleSelectSkill}
                    options={skills.map((skill) => ({
                      value: skill,
                      label: skill,
                    }))}
                  />
                </div> */}
                <p>
                  Category Number: {getCategoryNumber(ticketContent.ticket_id)}
                </p>
                <p>Ticket Number: {ticketContent.ticket_id}</p>
                <p>Member ID: {roomId}</p>
                <p>Response SLA: {response_sla}</p>
                <p>Repair SLA: {repair_sla}</p>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "space-around",
                    marginBottom: 20,
                  }}
                >
                  {/* <button
                    className="btn btn-yellow"
                    onClick={() => {
                      setIsNoteVisible(!isNoteVisible);
                    }}
                  >
                    View notes
                  </button> */}
                  <HexButton
                    className="btn btn-light text-dark"
                    data-toggle="modal"
                    data-target="#add_note_dialog"
                  >
                    Add note
                  </HexButton>
                  <HexButton
                    className="btn btn-light text-dark"
                    data-toggle="modal"
                    data-target="#schedule-meeting"
                  >
                    Add appointment
                  </HexButton>
                </div>
                {ticketContent.note && (
                  <Fragment>
                    <h4 style={{ marginBottom: 0 }}>Notes</h4>
                    {ticketContent && ticketContent.note && (
                      <div style={{ height: 200 }}>
                        {ticketContent.note
                          .sort((a, b) => b.time - a.time)
                          .map((item, index) => (
                            <NoteItem
                              key={index}
                              note={item}
                              onClickAttachment={onClickAttachment}
                            />
                          ))}
                      </div>
                    )}
                  </Fragment>
                )}
              </div>
            )}
          </div>
          <div className="modal-footer">
            <HexButton
              type="button"
              className="btn btn-orange"
              data-dismiss="modal"
            >
              Back
            </HexButton>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TicketDetailModal;



// WEBPACK FOOTER //
// ./src/components/TicketDetailModal/index.js